export default __webpack_public_path__ + "static/media/teamtryton.176ec0e5.png";